
import { LevelConfig } from '../components/LevelConfig';
import Player from '../components/Player';
import { PathPoint } from '../components/PathPoint';
import GameScene from './Game';

/**
 * Visual Depth Hierarchy (Z-Index):
 * 1000: Drag Troops Display (Text)
 * 100:  Drag Arrow & Line
 * 10:   Active Paths (during drag interaction)
 * 5:    PathMovement (Troops)
 * 2:    Nodes
 * 1:    Inactive Paths (Trace & HitArea)
 * 0:    Background
 */

export default class GameLevel extends GameScene {
    private level: any;

    constructor() {
        super({key: 'GameLevel'});
    }

    public init(levelConfig: LevelConfig): void {
        super.init(levelConfig);

        this.level = levelConfig;

        // Players
        this.level.players.forEach((player: any) => {
            this.getPlayers().add(player.id, player.type, player.color);
        });

        // Nodes
        this.level.nodes.forEach((node: any) => {
            this.getNodes().add(node.id, node.x, node.y, this.getPlayers().byId(node.player), node.options);
        });

        // Set Player Population
        this.getPlayers().players.forEach((player: Player) => {
            player.population = this.getNodes().sumPopulationForPlayer(player.id);
            
            if(this.level.globalPopulationSupply === -1) {
                player.supply = -1;
            }else{
                player.supply = this.getNodes().sumSupplyForPlayer(player.id) + this.level.globalPopulationSupply;
            }
        });

        // Game Level Variables
        this.score = this.level.score;
        this.initialPlayerSupply = this.getPlayers().byId('Player').supply;
        this.initialPlayerPopulation =  this.getPlayers().byId('Player').population;

        // Paths
        this.level.paths.forEach((path: any) => {
            const node1 = this.getNodes().byId(path.node1);
            const node2 = this.getNodes().byId(path.node2);

            // additionalPoints
            const additionalPoints: PathPoint[] = Array.isArray(path.additionalPoints)
                ? path.additionalPoints.map((point: any) => ({
                    x: point.x,
                    y: point.y
                }))
                : [];

            this.getPaths().add(node1, node2, additionalPoints);
        });
    }

    create(): void {
        super.create();

        // BG
        const bg = this.add.image(this.width / 2, this.height / 2, this.level.bg).setOrigin(.5);
        this.children.sendToBack(bg);
    }
}